// extracted by mini-css-extract-plugin
export default {"container":"ThankYou_container__btKep","card":"ThankYou_card__tm9AO","icon":"ThankYou_icon__zlMnE","eyebrow":"ThankYou_eyebrow__ChJFs"};